import Vue from 'vue'
import ProductQuickPreviewButton from '@/categories/components/ProductQuickPreviewButton.vue'
import ProductPreview from '@/categories/components/ProductPreview.vue'

export const initProductQuickReview = (selector: string) => {
  const mountEls = document.querySelectorAll(selector)

  if (!mountEls) return

  mountEls.forEach((mountEl: any) => {
    const productId = Number(mountEl.getAttribute('data-product-id'))
    const productGroupIdsText = mountEl.getAttribute('data-product-group-ids')
    const productGroupIds = productGroupIdsText ? productGroupIdsText.split(',') : []

    new Vue({
      render: h => h(ProductQuickPreviewButton, {
        props: {
          initProductId: productId.toString(),
          productGroupIds
        }
      })
    }).$mount(mountEl)
  })
}

export const initProductQuickReviewModal = (selector: string) => {
  const mountEl = document.querySelector(selector)
  if (!mountEl) return

  new Vue({
    render: h => h(ProductPreview)
  }).$mount(mountEl)

}
